import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/cn';

type PaperThumbnailStripProps = {
  urls: string[];
  activeIndex: number;
  onSelect: (index: number) => void;
  className?: string;
};

export function PaperThumbnailStrip({
  urls,
  activeIndex,
  onSelect,
  className,
}: PaperThumbnailStripProps): ReactElement | null {
  const { t } = useTranslation();
  if (urls.length <= 1) return null;

  return (
    <nav
      aria-label={t('audit.gradeStudio.pagesNav')}
      className={cn(
        'flex gap-2 overflow-x-auto border-b border-slate-200/70 bg-slate-50/90 px-3 py-2 dark:border-slate-700/60 dark:bg-slate-900/50',
        className
      )}
    >
      {urls.map((url, i) => (
        <button
          key={`${url}-${i}`}
          type="button"
          onClick={() => onSelect(i)}
          className={cn(
            'relative h-16 w-12 shrink-0 overflow-hidden rounded-lg border-2 transition-all',
            i === activeIndex
              ? 'border-dg-accent-grade shadow-sm ring-2 ring-dg-accent-grade/25'
              : 'border-transparent opacity-80 hover:opacity-100'
          )}
        >
          <img src={url} alt="" className="h-full w-full object-cover" />
          <span className="sr-only">{t('audit.gradeStudio.pageN', { n: i + 1 })}</span>
        </button>
      ))}
    </nav>
  );
}
